// DEPENDENCIES
import React from "react";

// CSS
import "./ConfirmRemovePhaseDialog.css";

// MUI COMPONENTS
import {
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
} from "@mui/material";

// REACT COMPONENT
const ConfirmRemovePhaseDialog = (props) => {
	// INPUT HANDLERS
	const confirmButtonClicked = () => {
		props.onConfirm();
	};

	// RENDER
	return (
		<Dialog
			id="confirmRemovePhaseDialog"
			open={props.open}
			fullWidth
			onClose={props.onCancel}
		>
			<DialogTitle id="confirmRemovePhaseDialogTitle">
				Warning
			</DialogTitle>
			<DialogContent id="confirmRemovePhaseDialogContent">
				<div className="confirmRemovePhaseDialogRow">
					Remove{props.jobName ? ` "${props.jobName}"` : " this phase"}{" "}
					from Design Jobs?
				</div>
				<div className="confirmRemovePhaseDialogRow confirmRemovePhaseDialogHint">
					This only removes it from this list. Its Spec Book, Scope of
					Work, and change history will remain saved and will show up
					again if this phase is ever added back.
				</div>
				<div className="dialogButtons">
					<Button onClick={props.onCancel} variant="outlined">
						Cancel
					</Button>
					<Button
						onClick={confirmButtonClicked}
						variant="contained"
						color="error"
					>
						Remove
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

// EXPORT
export default ConfirmRemovePhaseDialog;
